import React from "react";
import { Link } from "react-router-dom";
import GenreFavoritesContainer from "~/Containers/GenreFavoritesContainer";
import styled from "styled-components";

export const WrapperSection = styled.section`
  margin-bottom: 20px;
`;
export const Wrapper = styled.section`
  line-height: 18px;
  margin-bottom: 6px;
  display: inline-block;
  background-color: #eaeaea;
  padding: 6px 12px;
  margin-right: 8px;
  border-radius: 5px;
  a {
    &:hover {
      color: #333;
    }
  }
`;
const UserFavoriteGenres = ({ dir }) => (
  <GenreFavoritesContainer
    dir={dir}
    render={({ genres }) => {
      return (
        genres.length > 0 && (
          <WrapperSection>
            <div className="totd-header mb">
              <h3>Favorite Genres</h3>
            </div>
            <div>
              {genres.map((genre) => (
                <Wrapper>
                  <Link to={`/genre/${genre.id}`}>{genre.name}</Link>
                </Wrapper>
              ))}
            </div>
          </WrapperSection>
        )
      );
    }}
  ></GenreFavoritesContainer>
);

export default UserFavoriteGenres;
